import DownloadButton from '@/components/Elements/Button/DownloadButton'
import ViewFileButton from '@/components/Elements/Button/ViewFileButton'
import { Flex } from '@chakra-ui/react'

const FileViewCell = ({ getValue }) => {
  const file = getValue()
  if (!file?._id) {
    return <>No File</>
  }

  return (
    <Flex gap={1}>
      <ViewFileButton fileId={file?._id} />
      <DownloadButton fileId={file?._id} fileName={file?.originalFileName} />
    </Flex>
  )
}

export default FileViewCell
